import { GOV_IMG_PRE_PATH, LINK_PRE_PATH, UrlPre } from './index';

export const headBg = UrlPre + 'PC/governmentAffair.jpg ';
export const headBgM = UrlPre + 'M/governmentAffair.jpg';
export const frameSrc = GOV_IMG_PRE_PATH + 'pc/e6135a8cbc3b124586a0daeebbafde4577b05061e1aec71bfc024f990b39491c.jpg';
export const frameSrcM = GOV_IMG_PRE_PATH + 'm/0943bd6f53c9633a6444c73e368df6150a409cd1de561f9b6fc830cb1b7eea40.jpg';
export const challenge = [
  {
    icon: GOV_IMG_PRE_PATH + 'pc/828bdd50c50295fc0f8c8aa61236f994c2c9685669e79bd64be9619241cb9121.png',
    title: '上传下达不及时，基层难覆盖',
    desc: '政务系统消息难以快速直达一线，缺乏高效沟通工具，需打造横纵立体式协作系统',
  },
  {
    icon: GOV_IMG_PRE_PATH + 'pc/82711e87842e0c59c298c8c0e0cded8a5357ee1b9e636878c4f42ce261cb2da5.png',
    title: '应用场景繁杂，亟需减负提效',
    desc: '难以开展“互联网+政务”多场景融合应用，需借助科技高效落实指令，提升协作效率',
  },
  {
    icon: GOV_IMG_PRE_PATH + 'pc/c2480ed47dccf91d0fbfe13becdbd77aabd271698442e83f646d2a7ad20f1a6d.png',
    title: '旧系统设备不一，孤岛式应用',
    desc: '各部门应用场景需求多样，设备基础各异，难以实现各委办厅局视频高效互联互通',
  },
  {
    icon: GOV_IMG_PRE_PATH + 'pc/3da2da93d9fe86f00a2869174d5d54cc4261f4d7f1da16b03f8db2fc0512e35b.png',
    title: '对信息安全及稳定性要求极高',
    desc: '因政府工作特性，对国产化水平及应用稳定性要求高，需全面保障运行安全可控',
  },
];
export const frame = [
  {
    title: '高效视频协同',
    icon: GOV_IMG_PRE_PATH + 'pc/bfb3d4b4b4b6729fa3595f0fc4c1ebb598a04a7d88399377c7eebc230cd20d0f.png',
  },
  {
    title: '政务提质增效',
    icon: GOV_IMG_PRE_PATH + 'pc/609a6fb857e26dbb03a554977ca511eec88077dbf0f4bef9906116053ba7c5cd.png',
  },
  {
    title: '融合互联互通',
    icon: GOV_IMG_PRE_PATH + 'pc/ed8c2ba4a6ab8fe18d0278c493f4cc93b488eed62aee613219605074829d8a4a.png',
  },
  {
    title: '信息安全稳定',
    icon: GOV_IMG_PRE_PATH + 'pc/7b22bddde2da475aff0ab5230102043bb66f9ffc7790e93bf76916e401538b8b.png',
  },
];
export const advantage = [
  {
    icon: GOV_IMG_PRE_PATH + 'pc/637f51e3970eebc4106dc96341b7b558d6b4e02309cb23227f13fe9f469c752c.png',
    title: '全自主可控',
    desc: '全自研底层技术，具备完全自主核心知识产权，支持信创解决方案，拥有全国产芯片硬件终端',
  },
  {
    icon: GOV_IMG_PRE_PATH + 'pc/38dce2824d488c5ae758fce697cff2ea0c3ac160ed624d6a1be2eceae25be60b.png',
    title: '超融合应用',
    desc: '视频会议、监控、直播、录播、数据、语音融合互通，统一媒体接入能力，软件定义架构，万方接入，视讯应用直达政务基层',
  },
  {
    icon: GOV_IMG_PRE_PATH + 'pc/4590cfa05af1e13de69f30b03e39d868f390128919bc1804edb5392b8731186b.png',
    title: '强稳定可靠',
    desc: '运营级集群架构，MCU资源池，多活热备，7年不间断稳定运营，打造了超大规模的政务云视频服务平台，无单点故障',
  },
  {
    icon: GOV_IMG_PRE_PATH + 'pc/7a10983c134bfdc2a3fc06764228285a7976f145d399623699e963f6ae1144f9.png',
    title: '全场景覆盖',
    desc: '覆盖指挥中心、大中小会议室、桌面、移动端、无人机等各类型终端，可灵活接入政务内外网、专网、互联网、4G/5G 等多网络环境',
  },
  {
    icon: GOV_IMG_PRE_PATH + 'pc/ba7fb7ba0a0f40557012ce829250051134a7fa360fd790dde54e3b843ca4fa6a.png',
    title: '高安全保密',
    desc: '国密算法端到端全链路加密，内外网融合的灵活部署方式+全面安全机制，通过等保三级2.0+可信云双重安全资质认证',
  },
  {
    icon: GOV_IMG_PRE_PATH + 'pc/6168c4ec4c0a7e0c82929cfbc66642c110409b54265fd059e84212c0d45af7e7.png',
    title: '开放式集成',
    desc: '全面开放API/SDK，深度融合政务服务场景，打造“互联网+政务”云视频应用新范式，为政务服务减负提效',
  },
];
export const scene = [
  {
    title: '会议会商',
    desc: '提供4K超高清视频、8米拾音高品质音频及丰富音视频接口，支持专业会控保障',
    pcUrl: GOV_IMG_PRE_PATH + 'pc/f70a93196e3ee65e658bcdfdf3a3fb03fa3a61d047035169c870e1723d60d925.jpg',
  },
  {
    title: '指挥调度',
    desc: '适应任意网络环境，快速接入多种前端设备，支持无限分屏还原现场实况',
    pcUrl: GOV_IMG_PRE_PATH + 'pc/285e2986f1d1813f1b831366044bb2bed119691119eea9641353688ed92d2f98.jpg',
  },
  {
    title: '应急管理',
    desc: '实现应急事件部署工作快速开展，助力“横向协作，纵向联动”立体式应急指挥工作落地',
    pcUrl: GOV_IMG_PRE_PATH + 'pc/0b3f23416f9a8dc962db133d26f584dc672e5ce8329abb50a6952e6d63dffc6a.jpg',
  },
  {
    title: '协同办公',
    desc: '支持多人进行音频、视频、桌面共享、白板书写、批注等多种办公协作应用',
    pcUrl: GOV_IMG_PRE_PATH + 'c96981ca7d4e89f0123af08fa6bcb26d4d5e158f897a4b3a40687485816cdd9a.jpg',
  },
  {
    title: '党建培训',
    desc: '统筹各级党组织和党员开展线上培训、智慧党建、党建监督、日常管理等工作，加强学习型党组织建设 ',
    pcUrl: GOV_IMG_PRE_PATH + 'defb9e74a3cd46ce4776bee64956614a2084ac9e48ead506a057d36ad3018279.jpg',
  },
  {
    title: '基层应用',
    desc: '加强基层治理体系落地，助推“综治、城管、应急”三网融合建设，提升基层治理水平，助力数字政务发展',
    pcUrl: GOV_IMG_PRE_PATH + 'pc/0bda5db4002c54dfd9c45ee055b777adb82ec459b0d266384cef265b820f53bb.jpg',
  },
];

export const caseList = [
  [
    {
      logo: GOV_IMG_PRE_PATH + '6bdad397b704c96f33415b6e004f94b72ef8798297dd2ac5e828aeb80260a406.jpg',
      title: '中国人民政治协商会议全国委员会',
      desc: '小鱼易连已连续多年为全国政协提供专业云视频会议设备及服务。如2020年为全国两会的“云上两会”采访提供云视频支撑；2021年强力保障“巩固拓展脱贫攻坚成果，全面实施乡村振兴战略”专题协商会云召开；2022年高效支撑十三届全国政协第63次双周协商座谈会“线上+线下”举办......小鱼易连搭建了“安全、稳定、高清、高效”的可视化互动沟通桥梁，让协商议政“云上”高效开展。',
      link: LINK_PRE_PATH + '1090',
    },
    {
      logo: GOV_IMG_PRE_PATH + 'pc/33547513019a480da4f19076798b04e96443154eb689fcce49a36998de0eae30.png',
      title: '中华全国总工会',
      desc: '中华全国总工会主办的第十一届金砖国家工会论坛第一阶段会议，采用远程连线方式举行。来自中国、南非、巴西、俄罗斯、印度等五国工会领导人、驻10个国家中资企业代表分别在11个海外会场，应用小鱼易连云视频实现高清流畅的跨国云会议。小鱼易连强有力的支撑和保障，让跨国会议轻松开展、让全球交流更有温度。',
      link: LINK_PRE_PATH + '1097',
    },
    {
      logo: GOV_IMG_PRE_PATH + 'd24640db016ba9155b769aead8fce59aa87fefda81363944c9ebafd266fd2596.jpg',
      title: '国家知识产权局',
      desc: '国家知识产权局举办的第16个开放日活动通过小鱼易连云视频，在全国十座城市共计十一个分会场实现了“超高清、低延时、安全、稳定”的云视频互动。通过异地远程联动，打破时空壁垒，以更具创新的沉浸式方式，为观众带来“同步开放、同屏互动”的精彩，实现足不出户“云游”国家知识产权局的效果。',
      link: LINK_PRE_PATH + '1006',
    },
    {
      logo: GOV_IMG_PRE_PATH + 'f29bb20c2250f4f0277d76f5339ed9f067b152f89cb3ae0fe3fdc1c7538f9f4b.jpg',
      title: '河北省政务云视频平台',
      desc: '河北省政府携手小鱼易连和河北省联通，共同打造了“大平台、大系统、大数据”政务云视频平台，实现纵向省、市、县、乡镇、村五级单位全连接，横向突破全省各政府机构间信息壁垒。截止目前，已经覆盖近7000间会议室、5.5万村级终端，最大支持6.5万方并发，为河北省政府的现代化治理注入了强大势能，赋能数字政府建设。',
      link: LINK_PRE_PATH + '1041',
    },
    {
      logo: GOV_IMG_PRE_PATH + '6d60f79d289e1cb1616e1a9049c18c01f9ada1ebe5ab63f528ec1b0daf87cdf9.jpg',
      title: '甘肃省文化和旅游厅',
      desc: '基于加密互联网，甘肃省文旅厅建设了覆盖全省10个重点景区的“高稳定、高质量、高网络适应性”的小鱼易连云视频平台，实现对全省文旅系统的音频、视频、数据、内容、即时通讯、业务的全面覆盖。小鱼易连的“硬核”助力，提升了甘肃文旅系统的决策效率和信息传递精准度，促进了文化和旅游产业的高质量发展，为高效推进全省智慧景区建设贡献力量。',
      link: LINK_PRE_PATH + '90b850',
    },
    {
      logo: GOV_IMG_PRE_PATH + '1c3ec4da5f9cf4037abf03a0d061adf1c3e26be44e52b444dc193b8451e1f8f2.jpg',
      title: '湖南省税务局',
      desc: '湖南省税务局纳税服务处基于小鱼易连云视频，建设了纳税服务“云交互”可视化系统，实现“省-市-县”三级贯通，覆盖全省14个市州、155个区县税务局及办税大厅，满足办税场景的云视频全覆盖，打通便民服务“最后一公里”，实现全省税务服务“见屏如见面”，为湖南省税收现代化跨越式发展铺平“新路子”。',
      link: LINK_PRE_PATH + '1067',
    },
  ],
  [
    {
      logo: GOV_IMG_PRE_PATH + 'pc/95841d92829f00d34142e286a9596286ef8d45dbeecf799207756eb496c4c7be.png',
      title: '广西桂融会平台',
      desc: '广西壮族自治区基于小鱼易连全国产化的云视频整体解决方案，建设了全国首个省级政务信创云视频平台——广西非涉密融合视频会议系统（简称“桂融会平台”），实现全区-市-县-乡-村五级高效、高质量视讯互通互联，提升政府行政效能和战疫能力，为全自治区的基层社会治理现代化、信息化、智能化夯实数字化基础。',
      link: LINK_PRE_PATH + '41bf49',
    },
    {
      logo: GOV_IMG_PRE_PATH + 'pc/daf7deef263caf2fca112fcd4322a92aa49ed170fca640d816d8aedb52a026f2.png',
      title: '北京市生态环境局',
      desc: '北京市生态环境局积极拥抱信创化部署，携手小鱼易连，基于全国产化的云视频软硬件整体解决方案，引入小鱼易连硬件视频终端、一体化智能终端和信创客户端，形成全局信创系统的进一步构建，在业务流程、应用场景上持续创新突破，以全信创的信息化系统，保障日常业务沟通需求，增强多媒体视频业务覆盖，为全局的数字化转型升级筑牢安全护城河、撑起安全保护伞。',
      link: LINK_PRE_PATH + '24949b',
    },
  ],
];
